import React from 'react';
import './ClickableSVG.scss';

interface ClickableSVGProps {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  buttonAction?: () => void;
  disabled?: boolean;
  title?: string;
  marginLeft?: boolean;
}

const ClickableSVG: React.FC<ClickableSVGProps> = ({
  Icon,
  buttonAction,
  disabled = false,
  title,
  marginLeft = false,
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled && buttonAction) {
          buttonAction();
        }
      }}
      title={title}
      className={`clickable-svg ${disabled ? "disabled" : ""} ${
        marginLeft ? "clickable-margin-left" : ""
      }`}
      role="button"
      aria-label={title || "Clickable SVG"}
    >
      <Icon />
    </div>
  );
};

export default ClickableSVG;
